(function () {
  if (window.__ksbDrawer) return;
  window.__ksbDrawer = true;

  var FREE_FROM = 6000; // cents; must match the shipping rule in the checkout
  var BOOK = '.cart-item--product-' + window.KSB_BOOK_HANDLE;
  var TRUCK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2 6h11v9H2z"/><path d="M13 9h4l4 4v2h-8z"/><circle cx="6" cy="17" r="1.8"/><circle cx="17" cy="17" r="1.8"/></svg>';

  function money(c) { return '$' + (c / 100).toFixed(2); }

  function enhance(d) {
    var heading = d.querySelector('.drawer__heading');
    if (heading && heading.textContent.trim() !== 'Your cart') heading.textContent = 'Your cart';

    var items = d.querySelector('cart-drawer-items');
    var body = d.querySelector('.cart-drawer__body');
    var bar = d.querySelector('.ksb-ship');
    if (items && body && d.querySelector(BOOK)) {
      if (!bar) {
        bar = document.createElement('div');
        bar.className = 'ksb-ship';
        bar.innerHTML = '<p class="ksb-ship__msg" role="status"></p><div class="ksb-ship__track"><span class="ksb-ship__fill"></span><div class="ksb-ship__mover"><span class="ksb-ship__truck">' + TRUCK + '</span></div></div>';
        body.insertBefore(bar, body.firstChild);
      }
      var sub = parseInt(items.getAttribute('data-subtotal') || '0', 10) || 0;
      var left = FREE_FROM - sub;
      var pct = Math.max(0, Math.min(100, (sub / FREE_FROM) * 100)) + '%';
      var msg = left > 0 ? "You're <strong>" + money(left) + '</strong> away from FREE shipping' : 'You unlocked <strong>FREE shipping</strong>';
      var m = bar.querySelector('.ksb-ship__msg');
      if (m.innerHTML !== msg) m.innerHTML = msg;
      bar.querySelector('.ksb-ship__track').style.setProperty('--p', pct);
    } else if (bar) {
      bar.remove();
    }

    var tpl = document.getElementById('ksb-pay-icons');
    var ctas = d.querySelector('.cart__ctas');
    if (tpl && ctas && !d.querySelector('.ksb-pay')) {
      ctas.insertAdjacentElement('afterend', tpl.content.firstElementChild.cloneNode(true));
    }

    d.querySelectorAll('.drawer__inner-empty a.button').forEach(function (a) {
      if (a.dataset.ksbClose) return;
      a.dataset.ksbClose = '1';
      a.addEventListener('click', function (e) { e.preventDefault(); d.close(); });
    });
  }

  function init() {
    var d = document.querySelector('cart-drawer');
    if (!d) return;
    var queued = false;
    // the observer is paused while we write, so our own DOM changes never re-trigger it
    var obs = new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        obs.disconnect();
        try { enhance(d); } finally { obs.observe(d, { childList: true, subtree: true }); }
      });
    });
    enhance(d);
    obs.observe(d, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
